export enum InviteStatusEnum {
  Sent = "sent",
  Viewed = "viewed",
  Rejected = "rejected",
  Booked = "booked",
  Expired = "expired",
}

